module.exports = __webpack_public_path__ + "assets/images/91da21266255c6992d4e075db7972f6b.png";